import { render, staticRenderFns } from "./auditOfBpsList.vue?vue&type=template&id=28c5ddb1&scoped=true&"
import script from "./auditOfBpsList.vue?vue&type=script&lang=ts&"
export * from "./auditOfBpsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c5ddb1",
  null
  
)

export default component.exports